import React, { useState, useEffect } from "react"

const defaultContext = {
  searchParam: ''
}

export const SearchContext = React.createContext(defaultContext)

export const SearchContextProvider = ({ children }) => {
  // Always initialize with empty string for consistent SSR/client hydration
  const [searchParam, setSearchParamState] = useState('')
  
  // Load from sessionStorage AFTER hydration to prevent mismatch
  useEffect(() => {
    const stored = sessionStorage.getItem('njtSearchParam')
    if (stored) {
      setSearchParamState(stored)
    }
  }, [])
  
  // Wrapper function that also saves to sessionStorage
  const setSearchParam = (value) => {
    setSearchParamState(value)
    if (typeof window !== 'undefined') {
      if (value) {
        sessionStorage.setItem('njtSearchParam', value)
      } else {
        sessionStorage.removeItem('njtSearchParam')
      }
    }
  }
 
  return (
    <SearchContext.Provider value={{ searchParam, setSearchParam }}>
      {children}
    </SearchContext.Provider>
  )
}